import axios from "axios";

export const GetSintomaAcupunturaById = async (id) => {
  const response = await axios.get(`/api/sintoma/${id}`);
  return response.data;
};
